<template>
    <div class="camera-box">

        <video id="video" v-if="!isIE"  :width="videoWidth" :height="videoHeight" v-show="!imgSrc"></video>
        <div id="camera" v-if="isIE" :style="{'z-index':cameraZindex}"></div>
        <div class="video_bg_wrapper" >
            <img :src="require('@/assets/img/camera/border.png')"  class="img_border">
            <img :src="require('@/assets/img/camera/user.png')"  class="img_user">
            <img :src="require('@/assets/img/camera/scan.png')"  class="img_scan">
            <p>请确保您的面部全部显示在识别区域</p>
<!--            <p class="countDowmInfo"></p>-->
        </div>
        <canvas id="canvas" :width="videoWidth" :height="videoHeight"></canvas>
        <img :src="imgSrc" id="img" style="z-index: 10000" v-if="imgSrc">
<!--        <div class="img_bg_wrapper">-->
<!--            <img :src="require('@/assets/img/camera/border.png')" class="img_border">-->
<!--            <img :src="require('@/assets/img/camera/user.png')" class="img_user">-->
<!--        </div>-->
        <div class="btn_wrapper">
            <el-button type="primary" size="small" v-if="!imgSrc" @click="setImage">{{imgSrc?'重新拍照':'拍照'}}</el-button>
            <el-button type="primary" size="small" v-if="imgSrc" @click="resSetImage" >重新拍照</el-button>
            <el-button type="primary" size="small" v-if="imgSrc" @click="setFileUpload" >上传</el-button>
        </div>

    </div>
</template>

<script>
    import {isIEBrowser} from '@/utils/index';
    import webcam from "webcamjs";

    export default {
        name: 'Camera',
        props: {
            //【必选】CameraDialog弹窗显示状态
            show: {type: Boolean},
        },
        data() {
            return {
                videoWidth: '400',
                videoHeight: '300',
                isIE:false,
                cameraZindex:10001,
                thisCancas: null,
                thisContext: null,
                thisVideo: null,
                imgSrc: ``,
                webcamConfig:{
                    width: 360,
                    height: 260,
                    swfURL:'/static/swfs/webcam.swf',
                    flashNotDetectedText:'没有检测到 Adobe Flash Player。请下载Adobe Flash Player ActiveX版插件后调用摄像头拍照。',
                    noInterfaceFoundText:"没有找到支持的摄像头接口。",
                    image_format: 'png',
                }
            }
        },
        created() {
            this.isIE =  isIEBrowser();
            const _this = this;
            if(this.isIE){
                webcam.set(_this.webcamConfig);
            }
        },
        mounted() {
            if (this.show) this.getCompetence()
        },
        methods: {
            getCompetence() {

                var _this = this;

                this.thisCancas = document.getElementById('canvas')
                this.thisContext = this.thisCancas.getContext('2d')
                this.thisVideo = document.getElementById('video')
                // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
                if (navigator.mediaDevices === undefined) {
                    navigator.mediaDevices = {}
                }


                if(this.isIE){

                    webcam.set(_this.webcamConfig);
                    webcam.on( 'load', function() {
                        _this.cameraZindex = 10002;
                        // console.log('webcamConfigLoaded')
                    } );
                    webcam.on( 'live', function() {
                        _this.cameraZindex = 10001;
                        // console.log('liveLoaded')
                    } );
                    webcam.on( 'error', function(error) {
                        // console.log('error:',error)
                        _this.$message({
                            type:'error',
                            message:'访问摄像头媒体失败。'
                        })
                        setTimeout(function(){
                            _this.$emit('cameraAskFailure');
                        },1000)

                    } );
                    webcam.attach( '#camera' );

                    return
                }

                // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
                // 使用getUserMedia，因为它会覆盖现有的属性。
                // 这里，如果缺少getUserMedia属性，就添加它。

                if (navigator.mediaDevices.getUserMedia === undefined) {
                    navigator.mediaDevices.getUserMedia = function (constraints) {
                        // 首先获取现存的getUserMedia(如果存在)

                        var getUserMedia = (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) || navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
                        // 有些浏览器不支持，会返回错误信息
                        // 保持接口一致
                        if (!getUserMedia) {
                            setTimeout(function(){
                                _this.$emit('cameraAskFailure');
                            },1000)
                            return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
                        }

                        if(getUserMedia){
                            // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
                            return new Promise(function (resolve, reject) {
                                getUserMedia.call(navigator, constraints, resolve, reject)
                            })
                        }else{
                            setTimeout(function(){
                                _this.$emit('cameraAskFailure');
                            },1000)
                            return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
                        }


                    }
                }


                var constraints = {
                    audio: false,
                    video: {width: this.videoWidth, height: this.videoHeight, transform: 'scaleX(-1)'}
                }
                navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
                    // 旧的浏览器可能没有srcObject
                    if ('srcObject' in _this.thisVideo) {
                        _this.thisVideo.srcObject = stream
                    } else {
                        // 避免在新的浏览器中使用它，因为它正在被弃用。
                        _this.thisVideo.src = window.URL.createObjectURL(stream)
                    }
                    _this.thisVideo.onloadedmetadata = function (e) {
                        _this.thisVideo.play()
                    }
                }).catch(err => {
                    this.$message({
                        type:'error',
                        message:'访问摄像头媒体失败。'
                    })
                    setTimeout(function(){
                        _this.$emit('cameraAskFailure');
                    },1000)

                })
            },
            setImage() {
                const _this = this;
                if(this.isIE || window.ActiveXObject || "ActiveXObject" in window ){
                    webcam.snap( function(data_uri) {
                        _this.imgSrc = data_uri;
                        _this.cameraZindex = 10000;
                    } );
                }else{
                    // 点击，canvas画图
                    _this.thisContext.drawImage(_this.thisVideo, 0, 0, _this.videoWidth, _this.videoHeight)
                    // 获取图片base64链接
                    var image = this.thisCancas.toDataURL('image/png')
                    _this.imgSrc = image;
                }

                // console.log(_this.imgSrc)
                // this.$emit('refreshDataList', this.imgSrc)
            },
            resSetImage(){
                this.imgSrc = '';
                this.cameraZindex = 10001;
            },
            convertBase64UrlToBlob(urlData){
                var bytes=window.atob(urlData.split(',')[1]);        //去掉url的头，并转换为byte
                //处理异常,将ascii码小于0的转换为大于0
                var ab = new ArrayBuffer(bytes.length);
                var ia = new Uint8Array(ab);
                for (var i = 0; i < bytes.length; i++) {
                    ia[i] = bytes.charCodeAt(i);
                }
                return new Blob( [ab] , {type : 'image/png'});
            },
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(',')
                var mime = arr[0].match(/:(.*?);/)[1]
                var bstr = atob(arr[1])
                var n = bstr.length
                var u8arr = new Uint8Array(n)
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n)
                }
                return new File([u8arr], filename, {type: mime})
            },
            stopNavigator() {

                this.thisVideo && this.thisVideo.srcObject && this.thisVideo.srcObject.getTracks() ?this.thisVideo.srcObject.getTracks()[0].stop():null;//结束关闭流
            },
            //上传图片
            setFileUpload() {
                var imgFile = null;
                if(this.isIE || window.ActiveXObject || "ActiveXObject" in window ){
                    imgFile = this.convertBase64UrlToBlob(this.imgSrc);
                }else{
                    imgFile =  this.dataURLtoFile( this.imgSrc,'face.png');
                }

                const formData = new FormData();
                formData.append('file', imgFile);

                if(imgFile){
                    // 校验人脸信息
                    this.$http.post('/document/sysPersonFaces/faceDetect',formData ).then(res => {
                        if(res.data.code == '1' && res.data.data == 1){
                                this.$http.post('/bigfileUpload/uploadFile',formData ).then(res => {
                                    if(res.data.code == "1"){
                                        var filePath = res.data.data;
                                        this.$emit('fileUploadSuccess', filePath);
                                        this.$message({message: "上传成功", type: "success"});
                                    }else{
                                        this.$message({message: "上传失败", type: "error"});
                                    }

                                }).catch(e => {
                                    this.$message({message: "上传失败", type: "error"});
                                })
                        }else{
                            this.$message({message: "未捕获到人脸信息或人脸信息超出，要求有且仅有一张有效人脸信息。", type: "error"});
                        }
                    }).catch(e => {
                        console.log(e)
                        this.$message({message: "上传失败", type: "error"});
                    })
                }


            },
        },
        watch: {
            show(val) {
                if (val) {
                    this.imgSrc = ``
                    this.getCompetence()
                } else {
                    this.stopNavigator()
                }
            },
        }
    }
</script>

<style lang="less" scoped>
    .camera-box {
        height: 360px;
        padding: 10px;
        margin:10px;
        position: relative;

        #camera {
            position: absolute;
            top: 10px;
            left: 10px;
            padding: 20px;
            border-radius: 40px;
            width: 360px;
            height:260px;
            z-index: 10002;
            border-radius: 40px;
            object{
                border-radius: 20px;

            }

        }
        #video{
            position: absolute;
            top: 10px;
            left: 10px;
            padding: 20px;
            border-radius: 40px;
        }
        #canvas{
            position: absolute;
            left: 36px;
            top: 30px;
            display: none;
            width:391px;
            border-radius: 20px;
            border-radius: 20px;
        }
        #img{
            position: absolute;
            left: 30px;
            top: 30px;
            width:360px;
            border-radius: 20px;
            z-index: 1000;
        }


        .video_bg_wrapper{
            position: absolute;
            top: 10px;
            left: 10px;
            img{
                position: absolute;
            }
            img.img_border{
                width: 400px;
                top: 0;
                left: 0;
                z-index: 9999;
            }
            img.img_user{
                /*display: none;*/
                top: 24px;
                width: 320px;
                height: 250px;
                left: 35px;
                z-index: 10001;

            }
            img.img_scan{
                z-index: 10001;
                display: none;
                position: absolute;
                top: -80px;
                left:20px;
                animation-duration: 10s;
                animation-iteration-count: infinite;
                animation-name:scanning;
                animation-timing-function: linear;
            }
            p{
                width: 300px;
                font-size: 16px;
                position: absolute;
                left: 70px;
                top: 290px;
            }
            p.countDowmInfo{
                color: black;
                opacity: 0.2;
                z-index: 10000;
                position: absolute;
                top: 70px;
                font-size: 64px;
                left: 174px;
                width: 50px;
                display: none;
            }
        }




        .img_bg_wrapper{
            position: absolute;
            top: 40px;
            left: 0px;
            display: none;
            img{
                position: absolute;
            }
            img.img_border{
                width: 320px;
                top: 0px;
                left: 0px;
            }
            img.img_user{
                top: 28px;
                left: 50px;
                width: 220px;
            }
        }

        .btn_wrapper{
            text-align: center;
            margin-top: 340px;
            .btn:focus{
                outline:none;
            }
        }

    }


    @keyframes scanning {
        0% {
            top:-80px;
        }
        50% {
            top:175px;
        }
        100%{
            top:-80px;
        }
    }


</style>